import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import { SkeletonMenuSection } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/SkeletonMenuSection/SkeletonMenuSection.tsx'
import { MenuQuickFilterCard } from './MenuQuickFiltersCard/MenuQuickFiltersCard'

export const MenuQuickFilters = observer(() => {
  const { quickFiltersMenuStore } = useConversationMenuContext()
  const { quickFilters, initInboxQuickFilter, loading } = quickFiltersMenuStore

  useEffect(() => {
    initInboxQuickFilter()
  }, [])

  if (loading) {
    return (
      <Box mb={'20px'}>
        <SkeletonMenuSection items={[64, 40, 56, 64, 40, 56]} />
      </Box>
    )
  }

  if (quickFilters.length === 0) return null

  return (
    <Box mb={'20px'}>
      {quickFilters.map((item) => (
        <MenuQuickFilterCard key={item.id} item={item} />
      ))}
    </Box>
  )
})
